import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Shield } from 'lucide-react';
import { useDocumentTitle } from '../utils/useDocumentTitle';
export function PrivacyPage() {
  useDocumentTitle('Política de Privacidad | Cricket');
  return <div className="min-h-screen bg-white" data-id="element-5077">
      <div className="max-w-3xl mx-auto px-6 py-12" data-id="element-5078">
        <Link to="/" className="inline-flex items-center gap-2 text-sm font-medium text-gray-400 hover:text-gray-900 transition-colors mb-10" data-id="element-5079">
          <ArrowLeft className="w-4 h-4" data-id="element-5080" />
          Volver al inicio
        </Link>

        <div className="flex items-center gap-3 mb-8" data-id="element-5081">
          <div className="p-2.5 bg-gray-100 rounded-xl" data-id="element-5082">
            <Shield className="w-6 h-6 text-gray-700" data-id="element-5083" />
          </div>
          <div data-id="element-5084">
            <h1 className="text-3xl font-bold text-gray-900 tracking-tight" data-id="element-5085">
              Política de Privacidad
            </h1>
            <p className="text-sm text-gray-400 mt-1" data-id="element-5086">
              Última actualización:{' '}
              {new Date().toLocaleDateString('es-DO', {
              year: 'numeric',
              month: 'long',
              day: 'numeric'
            })}
            </p>
          </div>
        </div>

        <div className="text-gray-700 leading-relaxed text-base space-y-6" data-id="element-5087">
          <section data-id="element-5088">
            <h2 className="text-xl font-bold text-gray-900 mb-3" data-id="element-5089">
              1. Información que Recopilamos
            </h2>
            <p data-id="element-5090">
              Cricket recopila información personal necesaria para la gestión de
              pedidos de alimentos corporativos, incluyendo: nombre completo,
              correo electrónico, empresa y sucursal asignada, historial de
              pedidos y preferencias alimentarias.
            </p>
          </section>

          <section data-id="element-5091">
            <h2 className="text-xl font-bold text-gray-900 mb-3" data-id="element-5092">
              2. Uso de la Información
            </h2>
            <p data-id="element-5093">La información recopilada se utiliza exclusivamente para:</p>
            <ul className="list-disc pl-6 mt-2 space-y-1" data-id="element-5094">
              <li data-id="element-5095">Procesar y gestionar pedidos de alimentos</li>
              <li data-id="element-5096">Aplicar subsidios corporativos correspondientes</li>
              <li data-id="element-5097">
                Generar reportes de consumo para las empresas contratantes
              </li>
              <li data-id="element-5098">Mejorar la calidad del servicio</li>
              <li data-id="element-5099">Comunicaciones relacionadas con el servicio</li>
            </ul>
          </section>

          <section data-id="element-5100">
            <h2 className="text-xl font-bold text-gray-900 mb-3" data-id="element-5101">
              3. Protección de Datos
            </h2>
            <p data-id="element-5102">
              Implementamos medidas de seguridad técnicas y organizativas para
              proteger tu información personal contra acceso no autorizado,
              alteración, divulgación o destrucción. Los datos se almacenan en
              servidores seguros con encriptación.
            </p>
          </section>

          <section data-id="element-5103">
            <h2 className="text-xl font-bold text-gray-900 mb-3" data-id="element-5104">
              4. Compartir Información
            </h2>
            <p data-id="element-5105">
              No vendemos ni compartimos tu información personal con terceros,
              excepto:
            </p>
            <ul className="list-disc pl-6 mt-2 space-y-1" data-id="element-5106">
              <li data-id="element-5107">
                Con tu empresa contratante (reportes de consumo y subsidios)
              </li>
              <li data-id="element-5108">Cuando sea requerido por ley o autoridad competente</li>
              <li data-id="element-5109">
                Con proveedores de servicios que nos ayudan a operar la
                plataforma
              </li>
            </ul>
          </section>

          <section data-id="element-5110">
            <h2 className="text-xl font-bold text-gray-900 mb-3" data-id="element-5111">
              5. Tus Derechos
            </h2>
            <p data-id="element-5112">
              Conforme a la legislación de República Dominicana, tienes derecho
              a:
            </p>
            <ul className="list-disc pl-6 mt-2 space-y-1" data-id="element-5113">
              <li data-id="element-5114">Acceder a tus datos personales</li>
              <li data-id="element-5115">Solicitar la corrección de datos inexactos</li>
              <li data-id="element-5116">Solicitar la eliminación de tus datos</li>
              <li data-id="element-5117">Oponerte al procesamiento de tus datos</li>
            </ul>
          </section>

          <section data-id="element-5118">
            <h2 className="text-xl font-bold text-gray-900 mb-3" data-id="element-5119">
              6. Cookies y Almacenamiento Local
            </h2>
            <p data-id="element-5120">
              Utilizamos almacenamiento local del navegador para mantener tu
              sesión activa y recordar tus preferencias. No utilizamos cookies
              de seguimiento de terceros.
            </p>
          </section>

          <section data-id="element-5121">
            <h2 className="text-xl font-bold text-gray-900 mb-3" data-id="element-5122">
              7. Contacto
            </h2>
            <p data-id="element-5123">
              Para consultas sobre privacidad o ejercer tus derechos, contacta
              a:{' '}
              <a href="mailto:soporte@cricket.do" className="text-gray-900 font-semibold hover:underline underline-offset-2" data-id="element-5124">
                soporte@cricket.do
              </a>
            </p>
          </section>
        </div>

        <div className="mt-16 pt-8 border-t border-gray-100" data-id="element-5125">
          <div className="flex items-center gap-2" data-id="element-5126">
            <img src="https://i.imgur.com/bxPZvDb.png" alt="Cricket Logo" className="h-7 w-auto object-contain" data-id="element-5127" />
          </div>
          <p className="text-xs text-gray-400 mt-3" data-id="element-5128">
            © {new Date().getFullYear()} Cricket. Todos los derechos
            reservados.
          </p>
        </div>
      </div>
    </div>;
}